import { render } from "./Espace.vue?vue&type=template&id=356606ac"
import script from "./Espace.vue?vue&type=script&lang=js"
export * from "./Espace.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__